import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PersonIcon from "@mui/icons-material/Person";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faInstagram, faTwitter, faWhatsapp, faYoutube } from '@fortawesome/free-brands-svg-icons';
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { logoutApiCall } from "../utils/Apicalls";
import "./Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [profileName, setProfileName] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setProfileName("");
    // Check if user is logged in
    const userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      setIsLoggedIn(true);

      // Check if user is admin
      try {
        const userData = JSON.parse(userDetails);
        let name = userData?.first_name || "";
        if (userData?.last_name) {
          name += " " + userData?.last_name;
        }
        setProfileName(name);
        if (["admin", "sales", "tennant"].indexOf(userData.role_id) !== -1) {
          setIsAdmin(true);
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = async () => {
    try {
      // Call the logout API
      const result = await logoutApiCall();

      // Clear localStorage regardless of API response
      localStorage.removeItem("userDetails");
      localStorage.removeItem("token");

      // Update state
      setIsLoggedIn(false);

      // Redirect to login page
      navigate("/login");

      // Log the result for debugging
      if (result?.status) {
        console.log("Logout successful");
      } else {
        console.warn("Logout API call failed, but local logout completed");
      }
    } catch (error) {
      console.error("Error during logout:", error);
      // Still clear localStorage and redirect even if API call fails
      localStorage.removeItem("userDetails");
      localStorage.removeItem("token");
      setIsLoggedIn(false);
      navigate("/login");
    }
  };

  const handleNavScroll = (section: any) => {
    setMenuOpen(false);
    if (location.pathname === "/") {
      // Already on home, scroll
      const el = document.getElementById(section);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  return (
    <header className="site-header mt-4">
      <div className="container">
        <div className="top-bar">
          <div className="contact-info">
            <a
              href="mailto:info@nishjeshsports-ai.com"
              className="contact-item"
              onClick={(e) => {
                window.location.href = "mailto:info@nishjeshsports-ai.com";
              }}
            >
              <i className="fas fa-envelope"></i> info@nishjeshsports-ai.com
            </a>
            <a href="tel:+19092359247" className="contact-item">
              <i className="fas fa-phone"></i> +1 909-235-9247 [whatsapp +1
              657-630-7025]
            </a>
          </div>
          <div className="social-links">
            <a
              // href="javascript:void(0)"
              // target="_blank"
              rel="noopener noreferrer"
              className="social-icon whatsapp"
            >
              <FontAwesomeIcon icon={faWhatsapp} size="2x" />
            </a>
            <a
              // href="javascript:void(0)"
              // target="_blank"
              rel="noopener noreferrer"
              className="social-icon youtube"
              aria-label="YouTube"
            >
              <FontAwesomeIcon icon={faYoutube} size="2x" />
            </a>
            <a
              // href="javascript:void(0)"
              className="social-icon twitter"
              // target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <FontAwesomeIcon icon={faTwitter} size="2x" />
            </a>
            <a
              // href="javascript:void(0)"
              className="social-icon instagram"
              // target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} size="2x" />
            </a>
            <a
              // href="javascript:void(0)"
              className="social-icon linkedin"
              // target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedin} size="2x" />
            </a>
          </div>
        </div>
        <nav className="main-nav">
          <div className="logo">
            <Link to="/" className="logo-link">
              <HomeIcon className="home-icon" />
              <span>Nishjesh Sports AI</span>
            </Link>
          </div>
          <button className="menu-toggle" onClick={toggleMenu}>
            <i className={`fas ${menuOpen ? "fa-times" : "fa-bars"}`}></i>
          </button>
          <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
            <li>
              <Link to="/">Home</Link>
            </li>
            {/* <li>
              <Link to="/contact">Contact</Link>
            </li> */}
            {isLoggedIn ? (
              <>
                <li className="nav-button logout-button">
                  <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  >
                    <AccountCircleOutlinedIcon /> {profileName}
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    slotProps={{
                      list: {
                        "aria-labelledby": "basic-button",
                      },
                    }}
                  >
                    {isLoggedIn && (
                      <MenuItem onClick={() => navigate("/admin-home")}>
                        <AdminPanelSettingsIcon
                          style={{ verticalAlign: "middle", marginRight: 4 }}
                        />
                        Admin View
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={() => {
                        handleClose();
                        handleLogout();
                      }}
                    >
                      <LogoutIcon className="logout-icon" /> Logout
                    </MenuItem>
                  </Menu>
                </li>
              </>
            ) : (
              <li className="nav-button">
                <Link
                  to="/login"
                  className="highlight"
                  style={{ color: "#FFFFFF", backgroundColor: "#9b5de5" }}
                >
                  Login
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
